import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
export default {
  name: "rank",
  computed: {
    ...userVuex.mapState(["userInfo", "isLogin"])
  },
  data() {
    return {
      isTab: 0,
      personalList: null,
      isLoading: false,
      userRank: 1
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          this.isLoading = true;
          const personalInfo = await this.getRankingPersonal();
          if (!personalInfo) {
            this.isLoading = false;
            return;
          }
          this.isLoading = true;
          this.personalList = personalInfo.list;
          this.userRank = personalInfo.ranking;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...userVuex.mapActions(["getRankingPersonal"]),
    onTab(value) {
      this.isTab = value;
    }
  }
};